var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"tipo-ocorrencia","rota-base":"/admin/tipo-ocorrencia","titulo":"TIPOS DE OCORRÊNCIA","titulo-singular":"Tipo de Ocorrência","colunas-extras":[
        { campo: "descricao", label: "Descrição", tipo: "string" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }